// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"1a5c5ceb","258":"de21bb0e","285":"7e0ba0dc","323":"36508542","401":"6590a852","828":"d95ba207"}[chunkId] + ".chunk.js";
};